import { OnChangeValue, ActionMeta } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { OptionType, colourStyles } from './styleConfig';

interface PredictMultiSelectProps {
  defaultValue: OptionType[];
  options: OptionType[];
  onChange: (
    newValue: OnChangeValue<OptionType, true>,
    action: ActionMeta<OptionType>,
  ) => void;
  optionMessage?: () => string;
  createText?: string;
  aiGenerated: string[];
  disabled: boolean;
}

function PredictMultiSelect({
  defaultValue,
  options,
  onChange,
  optionMessage,
  createText = '',
  aiGenerated,
  disabled,
}: PredictMultiSelectProps) {
  return (
    <CreatableSelect
      isMulti
      options={options}
      styles={colourStyles(!disabled ? aiGenerated : [])}
      defaultValue={defaultValue}
      onChange={onChange}
      placeholder=""
      noOptionsMessage={optionMessage}
      formatCreateLabel={(value) => `${createText} ${value}`}
      isDisabled={disabled}
    />
  );
}
export default PredictMultiSelect;
